(function () {
  'use strict';

  function getSharedHandles() {
    var params = new URLSearchParams(window.location.search);
    var wishlistParam = params.get('wishlist');

    if (!wishlistParam) return [];

    return wishlistParam.split(',').map(function (handle) {
      return handle.trim();
    }).filter(Boolean);
  }

  function waitForWishlist() {
    return new Promise(function (resolve) {
      if (window.NailinfinityWishlist && window.NailinfinityWishlist.isReady) {
        resolve(window.NailinfinityWishlist);
        return;
      }

      document.addEventListener('wishlist:ready', function () {
        resolve(window.NailinfinityWishlist);
      }, { once: true });
    });
  }

  function buildIdQuery(ids) {
    return ids.map(function (id) {
      return 'id:' + id;
    }).join(' OR ');
  }

  function buildHandleQuery(handles) {
    return handles.map(function (handle) {
      return 'handle:' + handle;
    }).join(' OR ');
  }

  function fetchProducts(section, queryString) {
    if (!queryString) return Promise.resolve('');

    var settings = JSON.parse(section.getAttribute('data-section-settings'));

    return fetch(settings.searchUrl + '?section_id=' + settings.sectionId + '&type=product&q=' + encodeURIComponent(queryString), {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.text();
    }).catch(function () {
      return '';
    });
  }

  function renderProducts(section, html) {
    var placeholder = section.querySelector('.wishlist-page__placeholder');
    var emptyState = section.querySelector('[data-wishlist-empty]');
    var loading = section.querySelector('[data-wishlist-loading]');
    var sharedNote = section.querySelector('[data-wishlist-shared-note]');

    if (loading) loading.hidden = true;

    var hasProducts = false;

    if (html) {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var source = temp.querySelector('.wishlist-page__placeholder');

      if (source && source.querySelector('.product-item')) {
        placeholder.innerHTML = source.innerHTML;
        hasProducts = true;
      }
    }

    if (!hasProducts) {
      placeholder.innerHTML = '';
    }

    if (emptyState) emptyState.hidden = hasProducts;

    if (sharedNote && hasProducts && getSharedHandles().length > 0) {
      sharedNote.hidden = false;
    }

    if (window.NailinfinityWishlist) {
      window.NailinfinityWishlist.updateUI();
    }
  }

  function loadWishlistProducts(section, wishlist) {
    var sharedHandles = getSharedHandles();
    var queryString;

    if (sharedHandles.length > 0) {
      queryString = buildHandleQuery(sharedHandles);
    } else {
      queryString = buildIdQuery(wishlist.getProductIds());
    }

    fetchProducts(section, queryString).then(function (html) {
      renderProducts(section, html);
    });
  }

  function initWishlistPage() {
    var section = document.querySelector('[data-section-type="wishlist-page"]');
    if (!section) return;

    waitForWishlist().then(function (wishlist) {
      loadWishlistProducts(section, wishlist);
    });

    document.addEventListener('wishlist:updated', function () {
      if (getSharedHandles().length > 0) return;

      waitForWishlist().then(function (wishlist) {
        loadWishlistProducts(section, wishlist);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistPage);
  } else {
    initWishlistPage();
  }
})();
